import React from 'react'
import { css } from '@emotion/react'
import { mq, colors, font } from 'plume-ui'
import { Help, HelpProps } from '../common/Help'

type Props = {
  sub?: string | JSX.Element
  right?: string | JSX.Element
  helpText?: string
  helpProps?: HelpProps
  className?: string
  children: React.ReactNode
  dataTestId?: string
}

export const CardTitle: React.FC<Props> = (props) => {
  return (
    <div
      css={css`
        margin: 0;
        padding-block-end: 16px;
        padding-inline: 16px;
        display: flex;
        justify-content: space-between;
        ${mq.large} {
          padding-inline: 0;
        }
      `}
      className={props.className}
      data-test-id={props.dataTestId}
    >
      <div className="section-title">
        <div
          css={css`
            margin: 0;
            display: inline-flex;
            align-items: center;
          `}
        >
          <h2
            css={css`
              margin: 0;
              font-size: 18px;
              line-height: 1.5;
              letter-spacing: 0.02em;
            `}
          >
            {props.children}
          </h2>
          {props.helpText && (
            <Help
              {...props.helpProps}
              css={css`
                margin-left: 3px;
                vertical-align: sub;
              `}
            >
              {props.helpText}
            </Help>
          )}
        </div>
        {props.sub ? (
          <span
            css={css`
              font-size: 13px;
              color: ${colors.textLight};
              margin-left: 12px;
              font-weight: ${font.weight.normal};
            `}
          >
            {props.sub}
          </span>
        ) : null}
      </div>
      <div
        css={css`
          display: grid;
          place-items: center;
        `}
      >
        <div
          css={css`
            font-size: 13px;
            color: ${colors.textLight};
            margin-left: 12px;
            font-weight: ${font.weight.normal};
          `}
        >
          {props.right}
        </div>
      </div>
    </div>
  )
}
